var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleArrowButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "#C6CCFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 11.6747L16.7088 15.5L13 19.3253L14.1415 20.5L19 15.5L14.1415 10.5L13 11.6747Z",
    fill: "#214BA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrowButton);
export default __webpack_public_path__ + "static/media/circle-arrow-button.aec5ef81425e9b1be1c00ca875c24d4d.svg";
export { ForwardRef as ReactComponent };